import React, { useState } from "react";
import styles from './style.module.css';
import { IoIosClose } from "react-icons/io";
import { exportSurgeryMetrics } from "../../services/kollectaHealthCore";

const SurgeryReportFilterTool = ({ closeModal, setFeedback }) => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const handleExport = async () => {
    setFeedback('isLoading');

    const dateParams = new URLSearchParams();
    if (startDate) dateParams.append('startDate', startDate);
    if (endDate) dateParams.append('endDate', endDate);

    try {
      const blob = await exportSurgeryMetrics('all', dateParams.toString());
      const downloadUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = 'metricas-cirurgias.xlsx';
      document.body.appendChild(a);
      a.click();

      URL.revokeObjectURL(downloadUrl);
      a.remove();
      setFeedback('isSuccess');
    } catch (error) {
      setFeedback('isError');
      console.error("Erro ao exportar o relatório:", error);
    }
  };

  return (
    <section className={styles.wrapper}>
      <div className={styles.top}>
        <h2>Exportar relatório de cirurgias</h2>
        <button onClick={() => closeModal(false)} className={styles.close}><IoIosClose /></button>
      </div>

      <div className={styles.container}>
        <div className={styles.subContainer}>
          <p style={{ marginBottom: '1rem', color: '#444' }}>
            Opcional: filtre o período pelas datas de resposta do questionário. Deixe em branco para exportar todo o histórico disponível.
          </p>
          <div className={styles.dateContainer}>
            <div className={styles.dateInputs}>
              <div className={styles.dateInput}>
                <label htmlFor="surgeryStartDate">Data de início:</label>
                <input
                  type="date"
                  id="surgeryStartDate"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className={styles.dateInput}>
                <label htmlFor="surgeryEndDate">Data de fim:</label>
                <input
                  type="date"
                  id="surgeryEndDate"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <button onClick={handleExport} className={styles.generalButton}>Exportar Relatório</button>
    </section>
  );
};

export default SurgeryReportFilterTool;
